import {Component, inject} from '@angular/core';
import {
  ColumnDef,
  DataTableComponent,
  TableActionEvent, TableStateEvent
} from "../../../../../shared/components/data-table/data-table.component";
import {BaseComponent} from "../../../../../shared/base/base-component";
import {ApiService} from "../../../../../core/api/api.service";
import {State} from "../../../../../shared/base/base-state";
import {
  GetAdminUserListItem,
  type GetTenantListItem,
  type GetTenantListParams,
  GetTenantListResponse
} from "../../../../../core/api/model";
import {ButtonComponent} from "../../../../../shared/components/button/button.component";
import {Constants} from "../../../../../core/constants/constants";
import {
  TableCellUserActionsComponent
} from "../../../../users/components/table-cell-user-actions/table-cell-user-actions.component";
import {
  TableCellTenantComponentComponent
} from "../../table-cell-tenant-component/table-cell-tenant-component.component";
import {OverlayService} from "../../../../../shared/components/overlay/overlay.service";
import {LinkCompanyToTenantComponent} from "../../link-company-to-tenant/link-company-to-tenant.component";

@Component({
  selector: 'app-tenants',
  imports: [
    DataTableComponent
  ],
  templateUrl: './tenants.component.html',
  styleUrl: './tenants.component.scss'
})
export class TenantsComponent extends BaseComponent {

  apiService = inject(ApiService);
  overlayService = inject(OverlayService);

  getTerminalListState = new State<GetTenantListResponse>();

  columnDefs: ColumnDef[] = [
    {title: 'Name', type: 'text', alignment: 'left', displayTemplate: '$name'},
    {title: 'Description', type: 'text', alignment: 'center', displayTemplate: '$description'},
    {title: 'created Date', type: 'date', alignment: 'center', displayTemplate: '$createdAt'},
    {title: 'Company Count', type: 'text', alignment: 'center', displayTemplate: '$companyCount'},
    {
      title: 'Actions', type: 'actions', actionsConfig: {
        components: [TableCellTenantComponentComponent]
      },
    }

  ]

  getCompanyTerminalList($event: TableStateEvent) {
    let request: GetTenantListParams = {
      pageNumber: $event.paginationEvent?.pageNumber,
      pageSize: $event.paginationEvent?.pageSize,
      search: $event.searchText
    }
    this.executeRequest<GetTenantListResponse>({
      state: this.getTerminalListState,
      request: this.apiService.getTenantList(request)
    });
  }

  onActionClicked($event: TableActionEvent) {
    let item: GetTenantListItem = $event.item;
    switch ($event.actionKey) {
      case 'linkCompany':
        this.onLinkCompanyClicked(item);
        break;
    }
  }

  onLinkCompanyClicked(tenant: GetTenantListItem) {
    this.overlayService.openModal(LinkCompanyToTenantComponent, {
      data: {
        sourceTenantId: tenant.id
      }
    });
  }
}
